module.exports = __webpack_public_path__ + "img/live.9f305eda.svg";